var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header',{attrs:{"title":_vm.$t((_vm.text + ".title"))}}),_c('v-main',[_c('v-container',[_c('VueMarkdown',[_vm._v(_vm._s(_vm.$t((_vm.text + ".text"))))])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }